import React, { useState } from 'react'
import { Col, Icon, Row } from 'antd'
import g2gImage from '../../../../assets/images/logo-full-white.png'
import g2gLogo from '../../../../assets/images/g2g.png'
import QRCode from 'qrcode.react'
import { CardEx, ModalEx } from '../../../../styles/shared.style'
import { isEmpty } from 'lodash'
import { useDeepEffect } from '../../../../utils/hooks'
import { useDispatch, useSelector } from 'react-redux'
import { fetchLocationByHero } from '../../../../modules/location'

const QrCodeModal = (props) => {
  const dispatch = useDispatch()
  const [qrCode, setQrCode] = useState('')
  const { visible, onClose, qrCodeData } = props
  const { locationList } = useSelector(
    (state) => ({
      locationList: state.location.locationList
    }),
    []
  )
  async function fetch() {
    await dispatch(fetchLocationByHero(qrCodeData.id))
  }
  useDeepEffect(() => {
    if (!isEmpty(qrCodeData)) {
      if (qrCodeData.heroType === 'SCOOTER') {
        fetch()
      }
    }
  }, [qrCodeData])

  useDeepEffect(() => {
    if (!isEmpty(qrCodeData)) {
      if (qrCodeData.heroType === 'SCOOTER') {
        if (!isEmpty(locationList)) {
          const location = locationList.locationDto[0]
          setQrCode(
            `${process.env.REACT_APP_USER_ENDPOINT}/home?heroId=${qrCodeData.id}&heroType=${qrCodeData.heroType}&latitude=${location.lat}&longitude=${location.lng}`
          )
        }
      } else {
        setQrCode(
          `${process.env.REACT_APP_USER_ENDPOINT}/home?heroId=${qrCodeData.id}&heroType=${qrCodeData.heroType}`
        )
      }
    }
  }, [qrCodeData])

  const CardTitle = (
    <Row gutter={8} type="flex" justify="center">
      <Col>
        <img src={g2gImage} alt="" height={35} />
      </Col>
    </Row>
  )

  function downloadQRCode(e) {
    e.preventDefault()
    const canvas = document.getElementById('qr-gen')
    const pngUrl = canvas
      .toDataURL('image/png')
      .replace('image/png', 'image/octet-stream')
    const downloadLink = document.createElement('a')
    downloadLink.href = pngUrl
    downloadLink.download = `${qrCodeData.name}.png`
    document.body.appendChild(downloadLink)
    downloadLink.click()
    document.body.removeChild(downloadLink)
  }

  return (
    <ModalEx
      title="QR Code"
      visible={visible}
      footer={null}
      onCancel={(e) => {
        onClose(e)
        setQrCode('')
      }}>
      {!isEmpty(qrCodeData) && (
        <CardEx title={CardTitle}>
          <Row>
            <Col span={24}>
              <Row type="flex" justify="center">
                <QRCode
                  id="qr-gen"
                  size={256}
                  value={qrCode}
                  bgColor={'#ffffff'}
                  fgColor={'#000000'}
                  level={'L'}
                  includeMargin={false}
                  imageSettings={{
                    src: g2gLogo,
                    x: null,
                    y: null,
                    height: 40,
                    width: 40,
                    excavate: true
                  }}
                />
              </Row>
            </Col>
            <Col span={24}>
              <Row type="flex" justify="center">
                <span
                  style={{
                    color: '#6ebf4b',
                    fontSize: 24,
                    fontWeight: 'bold'
                  }}>
                  {qrCodeData.name}
                </span>
              </Row>
            </Col>
          </Row>
        </CardEx>
      )}
      <Row
        gutter={24}
        type="flex"
        justify="center"
        style={{ marginTop: '15px' }}>
        <Col>
          <div style={{ cursor: 'pointer' }} onClick={() => fetch()}>
            <Row type="flex" justify="center">
              <Icon type="redo" style={{ fontSize: '18px' }} />
            </Row>
            <Row type="flex" justify="center">
              <span style={{ fontSize: '16px' }}>รีเฟรช</span>
            </Row>
          </div>
        </Col>
        <Col>
          <div style={{ cursor: 'pointer' }} onClick={(e) => downloadQRCode(e)}>
            <Row type="flex" justify="center">
              <Icon type="download" style={{ fontSize: '18px' }} />
            </Row>
            <Row type="flex" justify="center">
              <span style={{ fontSize: '16px' }}>บันทึก</span>
            </Row>
          </div>
        </Col>
      </Row>
    </ModalEx>
  )
}

export default QrCodeModal
